var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM19.46 9.12L16.68 10.27C16.4296 9.59606 16.0363 8.98431 15.5271 8.4768C15.0179 7.96929 14.4048 7.57806 13.73 7.33L14.88 4.55C16.98 5.35 18.65 7.02 19.46 9.12ZM12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15ZM9.13 4.54L10.3 7.32C9.61732 7.56879 8.99706 7.96338 8.48241 8.4763C7.96776 8.98923 7.57108 9.60815 7.32 10.29L4.54 9.13C4.94077 8.08602 5.55648 7.13793 6.34721 6.34721C7.13793 5.55648 8.08602 4.94077 9.13 4.54ZM4.54 14.87L7.32 13.72C7.56946 14.4 7.96453 15.0173 8.47755 15.5286C8.99058 16.0399 9.60916 16.4328 10.29 16.68L9.12 19.46C8.0785 19.057 7.13292 18.4404 6.34412 17.6498C5.55531 16.8593 4.94076 15.9124 4.54 14.87ZM14.88 19.46L13.73 16.68C14.4078 16.4287 15.0228 16.0329 15.5322 15.52C16.0416 15.0071 16.4333 14.3895 16.68 13.71L19.46 14.88C19.0581 15.9205 18.443 16.8655 17.6542 17.6542C16.8655 18.443 15.9205 19.0581 14.88 19.46Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.b23dcb00db701abcac8559fa6c339c00.svg";
export { ForwardRef as ReactComponent };